import { render, staticRenderFns } from "./UpSell.vue?vue&type=template&id=4ab19ad2&scoped=true&"
import script from "./UpSell.vue?vue&type=script&lang=js&"
export * from "./UpSell.vue?vue&type=script&lang=js&"
import style0 from "./UpSell.vue?vue&type=style&index=0&id=4ab19ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab19ad2",
  null
  
)

export default component.exports